import { render, staticRenderFns } from "./DashboardViewNew.vue?vue&type=template&id=0a39b58e&"
import script from "./DashboardViewNew.vue?vue&type=script&lang=js&"
export * from "./DashboardViewNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports